import { useCallback } from "react";

import { FormInstance } from "antd/es/form";
import { useIntl } from "react-intl";

import { FieldValidationErrors } from "@app/store/api/ApiService";

import getErrorMessageByCode from "../errorHandling/platformErrorCodes";

const useFieldValidation = (
  form: FormInstance,
  handleFinishFail?: () => void,
  isCreateForm?: boolean
) => {
  const intl = useIntl();

  return useCallback(
    (fieldsErrors: FieldValidationErrors[]) => {
      const fields = fieldsErrors
        .filter(({ customField, fieldName }) => customField || fieldName)
        .map(({ customField, error, fieldName }) => {
          // TODO: a little tidy up would be nice to have, but not strictly required: fieldName here is
          // platformFieldName, but we use internal field names in the form. However, for currently
          // supported unique standard fields, these two match.
          const formPath = customField
            ? ["customFields", isCreateForm ? String(customField.id) : customField.esKey]
            : fieldName!;

          return {
            errors: error.map(
              (error) => getErrorMessageByCode(intl, error.code, error) ?? error.message
            ),
            name: formPath,
          };
        });
      form.setFields(fields);
      if (fields.length) {
        form.scrollToField(fields[0].name);
      }
      handleFinishFail?.();
    },
    [form, handleFinishFail, intl, isCreateForm]
  );
};

export default useFieldValidation;
